import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Stack, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import { VerifyUser } from "redux/thunk/auth.thunk";
import { toast } from "react-hot-toast";

export default function TwoStepAuthenticationForm({ userId }) {
  const [otp, setOtp] = useState("");
  const [isSubmitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!otp.trim()) {
    toast.error("Please enter the OTP.");
    return;
  }
    try {
      setSubmitting(true);
      const res = await dispatch(VerifyUser({ userId, verificationCode: otp }));
      setSubmitting(false);

      if (res.type === "auth/verify-user/fulfilled") {
        toast.success("Login successful!");
        navigate("/dashboard/app", { replace: true });
      } else {
        console.log(res.payload);
        
        toast.error(res?.payload?.error || "Invalid OTP");
      }
    } catch (error) {
      setSubmitting(false);
      toast.error(error.message || "An error occurred.");
    }
  };

  return (
    <Stack spacing={3}>
      <TextField
        fullWidth
        label="One-Time Password (OTP)"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
      />
      <LoadingButton
        fullWidth
        size="large"
        variant="contained"
        onClick={handleSubmit}
        loading={isSubmitting}
      >
        Verify OTP
      </LoadingButton>
    </Stack>
  );
}
